import React, { Component } from 'react'
import PropTypes from 'prop-types'

class CardStore extends Component {
  render () {
    const backgroundStore = this.props.informations.bannerImage ? {
      backgroundImage: 'url(' + this.props.informations.bannerImage + ') !important'
    } : {}

    const vendorImage = this.props.informations.vendorImage
    return (
      <div
        className='card-store row bg-white radius px-1 border-color-ui-4 border'
        style={backgroundStore}
        data-vendor={this.props.informations.vendorId}
      >
        <div className='col-12'>
          <div className='store-logo txt-center mt-5 mb-2'>
            <div className='row align-items-center h-100'>
              <div className='col-auto mr-auto ml-auto border-color-ui-4 border px-half py-2 radius bg-white'>
                <img src={vendorImage} alt={this.props.informations.description} className='card-image-fallback img-fluid' />
              </div>
            </div>
          </div>

          <h3 className='txt-font-body txt-center color-ui-2 txt-body'>
            {this.props.informations.description}
          </h3>
          <div className='txt-center pt-1 pb-2'>
            <a herf={`/vendor?vendor=${this.props.informations.vendorId}`} className='color-brand-1 txt-body-sm'>
              Ver loja
            </a>
          </div>
        </div>
      </div>
    )
  }
}

CardStore.propTypes = {
  informations: PropTypes.object
}

export default CardStore



// WEBPACK FOOTER //
// ./src/Catalog/Vendor/CardStore/CardStore.js